import { INDORID_BASE_URL } from "src/api/rtk/indorsoftRu/indorsoftRuApi";
import { SupportTicketMessage, SupportTicketFile } from "src/api/rtk/indorsoftRu/slices/supportApiSlice";

export function formatFileSize(bytesString: string): string {
    const bytes = Number(bytesString);
    if (!Number.isFinite(bytes) || bytes <= 0) return "";
    if (bytes < 1024) return `${bytes} Б`;
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(1)} КБ`;
    const mb = kb / 1024;
    return `${mb.toFixed(1)} МБ`;
}

export function sortMessagesByDate(messages: SupportTicketMessage[] | undefined): SupportTicketMessage[] {
    if (!messages) return [];
    return [...messages].sort((a, b) => {
        const da = new Date(a.DATE_CREATE.replace(" ", "T"));
        const db = new Date(b.DATE_CREATE.replace(" ", "T"));
        return da.getTime() - db.getTime();
    });
}

export type MessagesByDateGroup = {
    dateKey: string;
    label: string;
    items: SupportTicketMessage[];
};

export function groupMessagesByDate(messages: SupportTicketMessage[]): MessagesByDateGroup[] {
    const formatter = new Intl.DateTimeFormat("ru-RU", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });

    const groupsMap = new Map<string, MessagesByDateGroup>();

    messages.forEach((msg) => {
        const [datePart] = msg.DATE_CREATE.split(" ");
        const [dd, mm, yyyy] = datePart?.split(".") ?? [];

        let dateKey = datePart ?? msg.DATE_CREATE;
        let label = datePart ?? msg.DATE_CREATE;

        if (dd && mm && yyyy) {
            const jsDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
            dateKey = `${yyyy}-${mm}-${dd}`;
            label = formatter.format(jsDate);
        }

        if (!groupsMap.has(dateKey)) {
            groupsMap.set(dateKey, { dateKey, label, items: [] });
        }
        groupsMap.get(dateKey)!.items.push(msg);
    });

    return Array.from(groupsMap.values());
}

const FILE_BASE_URL = INDORID_BASE_URL;

export function getSupportTicketFileUrl(hash: string): string {
    return `${FILE_BASE_URL}bitrix/tools/ticket_show_file.php?hash=${hash}&lang=ru&action=download`;
}

export function isImageFile(file: SupportTicketFile): boolean {
    const name = file.NAME?.toLowerCase() ?? "";
    return [".png", ".jpg", ".jpeg", ".gif", ".jfif", ".webp", ".svg"].some((ext) =>
        name.endsWith(ext),
    );
}

/**
 * Находит последнее прочитанное сообщение поддержки по ID
 */
export function findLastReadSupportMessage(
    messages: SupportTicketMessage[],
    lastReadId: number,
): SupportTicketMessage | undefined {
    if (lastReadId <= 0) return undefined;

    const exactMatch = messages.find((m) => {
        if (m.MESSAGE_BY_SUPPORT_TEAM !== "Y") return false;
        const msgId = Number(m.ID);
        return Number.isFinite(msgId) && msgId === lastReadId;
    });

    if (exactMatch) return exactMatch;

    return [...messages]
        .reverse()
        .find((m) => {
            if (m.MESSAGE_BY_SUPPORT_TEAM !== "Y") return false;
            const msgId = Number(m.ID);
            if (!Number.isFinite(msgId)) return false;
            return msgId <= lastReadId;
        });
}

/**
 * Находит последнее сообщение от пользователя
 */
export function findLastUserMessage(
    messages: SupportTicketMessage[],
): SupportTicketMessage | undefined {
    // Сообщения уже отсортированы по дате, идем с конца
    return [...messages]
        .reverse()
        .find((m) => m.MESSAGE_BY_SUPPORT_TEAM !== "Y");
}

export function formatMb(bytes: number): string {
    return (bytes / (1024 * 1024)).toFixed(2);
}


